// Settings that should probably be in a more general location
// Saving that for the UI rework

export const formSubtitleExtras = {
	sx: {
		fontWeight: 500,
		lineHeight: '24px',
		letterSpacing: '0.16px',
	},
};

export const tabsSxExtras = {
	'& .MuiTabs-indicator': { backgroundColor: '#E71F39' },
	'& .MuiTab-root': { color: '#595959' },
	'& .MuiButtonBase-root-MuiTab-root.Mui-selected': { color: '#E71F39' },
	// not sure how to put this gap more directly
	'& .MuiTabs-flexContainer': {
		gap: 4,
	},
};

export const tabExtras = {
	sx: {
		padding: '14px 0px',
		fontSize: '14px',
		fontWeight: 500,
		lineHeight: '19.6px',
		letterSpacing: '0.14px',
		textTransform: 'capitalize',
	},
};
